<!-- Intro de la suite (deck lámina 4 "Módulos / accesos rápidos"): grid de
     tarjetas con icono redondo, título, descripción y badge "Flows". -->
<section class="intro-suite" [class.brand-tr]="isTrBrand">
  <div class="intro-suite__header">
    <img
      src="../../assets/logos/logo-inprovider.png"
      [attr.alt]="brandName"
      class="intro-suite__logo"
    />
    <h1 class="intro-suite__title">Módulos y accesos rápidos</h1>
  </div>

  <div class="intro-suite__grid">
    @for (card of cards; track trackByKey($index, card)) {
      @if (card.disabled) {
        <div class="intro-suite__card is-disabled" title="No incluido en tu plan">
          <div class="intro-suite__card-top">
            <span class="intro-suite__icon">
              <i [class]="card.faIcon"></i>
            </span>
          </div>
          <h2 class="intro-suite__card-title">{{ card.title }}</h2>
          <p class="intro-suite__card-desc">{{ card.description }}</p>
        </div>
      } @else {
        <a
          class="intro-suite__card"
          [routerLink]="linkPath(card.link)"
          [queryParams]="linkQuery(card.link)"
        >
          <div class="intro-suite__card-top">
            <span class="intro-suite__icon">
              <i [class]="card.faIcon"></i>
            </span>
            @if (card.flowsBadge) {
              <span class="intro-suite__badge">
                <i class="fa-solid fa-diagram-project"></i> Flows
              </span>
            }
          </div>
          <h2 class="intro-suite__card-title">{{ card.title }}</h2>
          <p class="intro-suite__card-desc">{{ card.description }}</p>
        </a>
      }
    }
  </div>
</section>
